import React, { useState } from "react";
import { compose } from "redux";
import { claimsConnector } from "../../services/claims/claimsConnector";
import { withClaims } from "../../HoC/claims/withClaims";

//Todo: rename claimAuth to oneOf or something like that
const ClaimsWrapper = ({
  claims,
  claimAuth,
  requiredClaims,
  excludeClaimAuth,
  valueClaimAuth,
  children,
}) => {
  const [showComponent] = useState(initState);

  function initState() {
    let showComponentInit = true;

    if (excludeClaimAuth)
      showComponentInit = !excludeClaimAuth.some((ca) =>
        Object.keys(claims.data).includes(ca),
      );

    if (requiredClaims) {
      if (requiredClaims.every((ca) => Object.keys(claims.data).includes(ca)))
        showComponentInit = true;
      else return false;
    }

    if (claimAuth)
      showComponentInit = claimAuth.some((ca) =>
        Object.keys(claims.data).includes(ca),
      );

    if (showComponentInit && valueClaimAuth)
      showComponentInit = valueClaimAuth.some(
        (vca) => claims.data[vca.Type] === vca.Value,
      );

    return showComponentInit;
  }

  if (showComponent) return <React.Fragment>{children}</React.Fragment>;
  else return null;
};

export default compose(claimsConnector, withClaims)(ClaimsWrapper);
